// Centralised keyboard shortcuts. Most existing handlers (Cmd+Z undo,
// spacebar play/pause) live elsewhere; this module covers project / pattern
// / song actions and exposes a manifest the cheat-sheet panel consumes.

import { saveNamed } from './persistence.js';
import { createPattern } from './pattern.js';

export const SHORTCUTS = [
    { keys: '?',                   desc: 'Toggle this help panel' },
    { keys: 'Space',               desc: 'Play / pause' },
    { keys: '⌘/Ctrl + Z',          desc: 'Undo' },
    { keys: '⌘/Ctrl + Shift + Z',  desc: 'Redo' },
    { keys: '⌘/Ctrl + S',          desc: 'Save project (prompt for name)' },
    { keys: 'N',                   desc: 'New pattern (active = the new one)' },
    { keys: 'D',                   desc: 'Duplicate active pattern' },
    { keys: 'M',                   desc: 'Toggle Pattern / Song mode' },
    { keys: '← / →',               desc: 'Switch to previous / next pattern' },
    { keys: '1 – 9',               desc: 'Jump to pattern 1 – 9' },
    { keys: 'A W S E D F T G Y H U J K', desc: 'Live-input notes (Sampler / Synth / Piano)' },
    { keys: 'Z / X',               desc: 'Lower / raise live-input octave' },
];

export function bindShortcuts(ctx, panel) {
    document.addEventListener('keydown', (e) => {
        const tag = document.activeElement?.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA') return;
        const meta = e.metaKey || e.ctrlKey;
        const k = e.key;
        const lower = k.toLowerCase();

        if (k === '?' || (e.shiftKey && k === '/')) {
            e.preventDefault();
            panel?.toggle();
            return;
        }

        // Save project ─ Cmd/Ctrl+S
        if (meta && lower === 's' && !e.shiftKey) {
            e.preventDefault();
            const name = prompt('Save project as:', 'untitled');
            if (name) saveNamed(ctx, name);
            return;
        }

        // No-modifier letter / arrow shortcuts
        if (meta || e.altKey) return;

        if (lower === 'n') {
            e.preventDefault();
            const p = createPattern({ name: `Pattern ${ctx.patterns.list().length + 1}` });
            ctx.patterns.add(p);
            ctx.patterns.setActive(p.id);
            return;
        }
        if (lower === 'd') {
            e.preventDefault();
            ctx.patterns.duplicate(ctx.patterns.getActiveId());
            return;
        }
        if (lower === 'm') {
            e.preventDefault();
            const next = ctx.song.getMode() === 'song' ? 'pattern' : 'song';
            ctx.song.setMode(next);
            return;
        }
        if (k === 'ArrowLeft' || k === 'ArrowRight') {
            e.preventDefault();
            const list = ctx.patterns.list();
            const idx = list.findIndex(p => p.id === ctx.patterns.getActiveId());
            if (idx < 0) return;
            const next = k === 'ArrowLeft'
                ? (idx - 1 + list.length) % list.length
                : (idx + 1) % list.length;
            ctx.patterns.setActive(list[next].id);
            return;
        }
        if (/^[1-9]$/.test(k)) {
            e.preventDefault();
            const list = ctx.patterns.list();
            const target = list[parseInt(k, 10) - 1];
            if (target) ctx.patterns.setActive(target.id);
        }
    });
}
